import React from 'react';
import { Button, FontIcon, SvgIcon } from '@gik/ui';
import LoginProviders from './LoginProviders';
import { useAuthStore } from '@gik/auth/store/AuthStore';

export type ExternalLoginFormFilter = 'Facebook' | 'Google';

export interface IExternalLoginFormProps {
  className?: string;
  postUrl?: string;
  returnUrl?: string;
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
  filter?: ExternalLoginFormFilter;
  appendProviderToReturnUrl?: boolean;
  signup?: boolean;
}

// TODO: remove when .net core auth functionality is available
declare const window: LegacyReactWindow;

// TODO use BEM
export default function ExternalLoginForm({
  className = '',
  postUrl = '/Account/ExternalLogin',
  returnUrl = window.location.pathname + window.location.search,
  onSubmit,
  filter,
  appendProviderToReturnUrl,
  signup = false,
}: React.PropsWithChildren<IExternalLoginFormProps>): JSX.Element {
  const [showLoginButtons, setShowLoginButtons] = React.useState<boolean>(true);

  const handleOAuthButtonClick = function (e: React.FormEvent<HTMLFormElement>) {
    setShowLoginButtons(false);
    if (onSubmit) {
      onSubmit(e);
    }
  };

  const subscribeToNewsletter = useAuthStore(state => state.signupFormValues?.subscribeToNewsletter);

  // TODO: migrate to final-form
  return (
    <div className={`external-login-form-wrapper tw-space-y-4 ${showLoginButtons ? '' : 'working'} ${className}`}>
      {LoginProviders.filter(provider => {
        if (filter) {
          return provider.value == filter;
        } else {
          return true;
        }
      }).map(provider => (
        <form
          key={provider.value}
          className={`external-login-form`}
          name="external-login-form"
          action={`${postUrl}?ReturnUrl=${encodeURIComponent(
            // append provider to return URL so that frontend knows what the user signed up with
            returnUrl +
              (appendProviderToReturnUrl
                ? `${returnUrl.indexOf('?') > 0 ? '&' : '?'}provider=${provider.value.toLowerCase()}`
                : '')
          )}&provider=${provider.value}&subscribeToNewsletter=${subscribeToNewsletter}`}
          method="POST"
          onSubmit={e => {
            handleOAuthButtonClick(e);
          }}
        >
          <Button
            prepend={<SvgIcon set={'brand-icons'} name={provider.icon} />}
            key={provider.value}
            className={`social-login ${provider.className}`}
            type="submit"
            size="lg"
            fullWidth
          >
            {/* TODO: i18n */}
            {(signup ? 'Sign up with' : 'Login with') + ' ' + provider.label}
          </Button>
        </form>
      ))}
    </div>
  );
}
